module.exports = __webpack_public_path__ + "img/cbln1r1.0d6c3942.gif";